import React from "react";

function BS4_Badges() {
  return (
    <div>
      <h1>BS4_Badges Component</h1>
      <p>This is the BS4_Badges tutorial page content.</p>
    </div>
  );
}

export default BS4_Badges;
